import React from "react";
import "../../styles/2-Home/Home.css";
import { BsChevronDoubleDown, BsArrowRight } from "react-icons/bs";
import { BiChevronsDown } from "react-icons/bi";
import {
  HiOutlineChevronDoubleDown,
  HiChevronDoubleDown,
} from "react-icons/hi";
import Anselmo from "../../assets/images/anselmo.jpg";
import project1 from "../../assets/images/project-1.jpg";
import Animate from "./Animate";
import useLanguageContext from "../../hooks/useLanguageContext";

const Home = () => {
  const languageState = useLanguageContext();

  return (
    <section id="home">
      <div className="home__content">
        <img src={Anselmo} alt="Anselmo Del Hoyo" />
        <a href="#contact">
          <span className="content__icon">
            <HiOutlineChevronDoubleDown className="icon" />
            <HiOutlineChevronDoubleDown className="icon" />
            <BsChevronDoubleDown className="icon" />
            <BsChevronDoubleDown className="icon" />
            <HiOutlineChevronDoubleDown className="icon" />
            <HiChevronDoubleDown className="icon" />
            <BiChevronsDown className="icon" />
          </span>
        </a>
      </div>
      <h1 id="title" className="home__title">
        <span className="title__name">
          {languageState ? "I'm Anselmo Del Hoyo" : "Soy Anselmo Del Hoyo"}
        </span>
        <span className="title__skill">
          Front-End Developer
        </span>
      </h1>
      <article className="home__animation">
        <Animate />
      </article>
      <article className="home__project">
        <div className="project__features">
          <img src={project1} />
          <div className="features">
            <h3>Calculadora React</h3>
            <a href="#portfolio">
              <span>{languageState ? "more" : "más"}</span>
              <BsArrowRight />
            </a>
          </div>
        </div>
        <span className="project__number">01</span>
      </article>
    </section>
  );
};

export default Home;
